var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * WarningCircle component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconWarningCircle extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.51446 12C2.51446 6.76128 6.76128 2.51446 12 2.51446C17.2387 2.51446 21.4855 6.76128 21.4855 12C21.4855 17.2387 17.2387 21.4855 12 21.4855C6.76128 21.4855 2.51446 17.2387 2.51446 12ZM12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM12.7577 6.48448C12.7577 6.06628 12.4187 5.72725 12.0005 5.72725C11.5823 5.72725 11.2433 6.06628 11.2433 6.48448V11.2119C11.2433 11.6301 11.5823 11.9691 12.0005 11.9691C12.4187 11.9691 12.7577 11.6301 12.7577 11.2119V6.48448ZM12.0005 14.3945C11.1641 14.3945 10.4861 15.0725 10.4861 15.9089C10.4861 16.7453 11.1641 17.4234 12.0005 17.4234C12.8369 17.4234 13.515 16.7453 13.515 15.9089C13.515 15.0725 12.8369 14.3945 12.0005 14.3945Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconWarningCircle.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconWarningCircle.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconWarningCircle.prototype, "size", void 0);
if (customElements.get('cat-icon-warning-circle') === undefined) {
    customElements.define('cat-icon-warning-circle', BlocksIconWarningCircle);
}
